module.exports = __webpack_public_path__ + "media/images/webpage/hotels/539/floorguide/course-1-photo-9-c4184144235407defc66c60cc8db4759.webp";